import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Tachometer = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M12 4C6.486 4 2 8.486 2 14a9.89 9.89 0 001.051 4.445c.17.34.516.555.895.555h16.107c.379 0 .726-.215.896-.555A9.89 9.89 0 0022 14c0-5.514-4.486-10-10-10zm7.41 13H4.59A7.875 7.875 0 014 14c0-4.411 3.589-8 8-8s8 3.589 8 8a7.875 7.875 0 01-.59 3z",
    key: "k0"
  }), React.createElement("path", {
    d: "M10.939 12.939a1.53 1.53 0 000 2.561 1.53 1.53 0 002.121-.44l3.962-6.038a.034.034 0 000-.035.033.033 0 00-.045-.01l-6.038 3.962z",
    key: "k1"
  }));
});
Tachometer.displayName = 'Tachometer';
export var TachometerDimensions = {
  height: 24,
  width: 24
};